import React, { useState } from 'react';
import { LangProvider, useLang } from './i18n/LangContext';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import CopilotPanel from './components/CopilotPanel';
import DashboardPage from './pages/DashboardPage';
import ItemMasterPage from './pages/ItemMasterPage';
import InventoryPage from './pages/InventoryPage';
import OrdersPage from './pages/OrdersPage';
import VendorsPage from './pages/VendorsPage';
import ReportsPage from './pages/ReportsPage';
import './styles/App.css';

const AppInner = () => {
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [copilotOpen, setCopilotOpen] = useState(false);
  const { t } = useLang();

  const getPageTitle = () => {
    const titles = {
      dashboard: t.sidebar.dashboard,
      materials: t.sidebar.materials,
      inventory: t.sidebar.inventory,
      orders: t.sidebar.orders,
      suppliers: t.sidebar.suppliers,
      reports: t.sidebar.reports,
      settings: t.sidebar.settings,
    };
    return titles[activeMenu] || t.app.title;
  };

  const renderContent = () => {
    switch (activeMenu) {
      case 'dashboard': return <DashboardPage />;
      case 'materials': return <ItemMasterPage />;
      case 'inventory': return <InventoryPage />;
      case 'orders': return <OrdersPage />;
      case 'suppliers': return <VendorsPage />;
      case 'reports': return <ReportsPage />;
      case 'settings':
        return (
          <div className="content-placeholder">
            <div className="placeholder-icon">⚙️</div>
            <h2>{t.settings.title}</h2>
            <p>{t.settings.desc}</p>
          </div>
        );
      default: return <DashboardPage />;
    }
  };

  return (
    <div className="app">
      <Sidebar activeMenu={activeMenu} setActiveMenu={setActiveMenu} />
      <div className={`main-layout ${copilotOpen ? 'copilot-active' : ''}`}>
        <TopBar pageTitle={getPageTitle()} />
        <main className="main-content">
          {renderContent()}
        </main>
      </div>
      <CopilotPanel open={copilotOpen} onToggle={() => setCopilotOpen(!copilotOpen)} currentPage={activeMenu} />
    </div>
  );
};

const App = () => (
  <LangProvider>
    <AppInner />
  </LangProvider>
);

export default App;
